import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import historyFullStore from './referee-history/referee-history-full/referee-history-full-store';
import historySingleStore from './referee-history/referee-history-single/referee-history-single-store';
import refereeModel from './referee-model';
import refereePager from './referee-pager';
import service from './referee-service';
import clubService from '../club/club-service';

export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore
  },

  state: {
    loading: false,
    list: [],
    pager: refereePager.build(),
    model: refereeModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.refereeEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.refereeEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.refereeViewer.id,
        roles.refereeEditor.id
      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.refereeEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || refereeModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = refereePager.build();
      state.model = refereeModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    new({ commit }) {
      commit('MODEL', null);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    save({ getters, commit, rootGetters, dispatch }) {
      commit('LOADING', true);

      return service
        .save(getters.model, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.referee.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
        }).catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    destroy({ commit, dispatch, rootGetters }, id) {
      commit('LOADING', true);

      return service
        .destroy(id, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.referee.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .then(() => dispatch('list'))
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      clubService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'clubs', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/referee/referee-store.js